﻿const winWidthBreakpoint = 992
const scrollTopBreakpoint = 550

const mainContentSelector = ".main-content"
const isHeaderHiddenClass = "-isHeaderHidden"
const isHeaderStickClass = "-isHeaderSticky"

const willBeStickyClass = "-willBeSticky"
const headerScrollClass = ".m-header.-scroll"
const slideUpClass = "-slideUp"

// Header
// Use the CSS breakpoint, not innerWidth: anything overflowing the page makes mobile browsers report a wider window
const isMobileWidth = () => window.matchMedia(`(max-width: ${winWidthBreakpoint - 1}px)`).matches

const toggleHeaderScrollUp = () => {
    const isMobile = isMobileWidth()
    const isPastScrollBreakpoint = window.scrollY > scrollTopBreakpoint

    for(const el of document.querySelectorAll(headerScrollClass))
        isPastScrollBreakpoint || isMobile ?
            el.classList.remove(slideUpClass) :
            el.classList.add(slideUpClass)

    const mainContentEl = document.querySelector(mainContentSelector)

    if(!mainContentEl)
        return

    if(isPastScrollBreakpoint || isMobile) {
        document.querySelector("body").classList.add(isHeaderStickClass)
        mainContentEl.classList.remove(isHeaderStickClass)
        return
    }

    document.querySelector("body").classList.remove(isHeaderStickClass)
    mainContentEl.classList.add(isHeaderHiddenClass)
}

document.addEventListener("DOMContentLoaded", () => {
    toggleHeaderScrollUp()

    const headerEl = document.querySelector("#header")

    if(!headerEl)
        return

    isMobileWidth() ?
        headerEl.classList.add(willBeStickyClass) :
        headerEl.classList.remove(willBeStickyClass)

    // Mobile Menu
    if(!Mmenu) {
        console.error("Mmenu is null or undefined, could not setup mobile menu functionality")
        return
    }

    const handleMmenuIconAttrs = () => {
        const menuIcons = document.querySelectorAll(".mm-menu-icons")

        for(const icon of menuIcons) {
            icon.removeAttribute("inert")
            icon.classList.remove("mm-panel--opened")
        }
    }

    handleMmenuIconAttrs()

    const mmButtons = document.querySelectorAll(".mm-btn")

    for(const btn of mmButtons) {
        btn.addEventListener("click", () => {
            handleMmenuIconAttrs()
        })
    }

    const menu = new Mmenu("#mobileMenu", {
            navbar: {
                title: "Shop",
                titleLink: "/shop",
            },
            setSelected: {
                "hover": true
            },
            offCanvas: {
                position: "right-front"
            }
        },
        {
            offCanvas: {
                clone: false,
                page: {
                    selector: "#page",
                }
            }
        }
    )

    const api = menu.API
    let open = false

    const openMenu = function(){
        document.querySelector('body, #header').classList.add('-navActive')
        document.querySelector("#mobileNavButton").classList.add("-active")
        api.open()
        open = true
    }

    const closeMenu = function(){
        document.querySelector('body, #header').classList.remove('-navActive')
        document.querySelector("#mobileNavButton").classList.remove('-active')
        api.close()
        open = false
    }

    document.querySelector("#mobileNavButton").addEventListener("click", function (e){
        e.stopPropagation()
        open ? closeMenu() : openMenu()
    })

    document.querySelector(".mm-slideout").addEventListener("click", function(e) {
        closeMenu()
    })
})

document.addEventListener("scroll", () => {
    toggleHeaderScrollUp()
})

document.addEventListener("resize", () => {
    toggleHeaderScrollUp()
})

